import { render, staticRenderFns } from "./AnytimeExamination.vue?vue&type=template&id=efd60802&scoped=true"
import script from "./AnytimeExamination.vue?vue&type=script&lang=js"
export * from "./AnytimeExamination.vue?vue&type=script&lang=js"
import style0 from "./AnytimeExamination.vue?vue&type=style&index=0&id=efd60802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd60802",
  null
  
)

export default component.exports